import { makeStyles } from '@mui/styles';
import theme from 'src/style-system/theme';

export const useStyles = makeStyles({
  flexColumn: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
  },

  desktopFilterMainContainer: {
    position: 'sticky',

    padding: '20px 25px 0 50px',
    height: '100vh',
    overflow: 'scroll',
    // to not display scroll bar
    '&::-webkit-scrollbar': {
      display: 'none',
    },
    '-ms-overflow-style': 'none' /* IE and Edge */,
    scrollbarWidth: 'none' /* Firefox */,
  },

  filterSelectList: {
    display: 'flex',
    flexWrap: 'wrap',
    columnGap: '12px',
    rowGap: '15px',
    marginBottom: '30px',
  },

  filterNameWrapper: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    columnGap: '20px',
    marginBottom: '40px',
  },

  filterListWrapper: {
    width: 'auto',
    backgroundColor: theme.palette.whitePepper.main,
    borderRadius: '24px',
    padding: '10px 18px',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-around',
    columnGap: '5px',
  },

  filterContentContainer: {
    maxWidth: '360px',
    margin: '0 auto',
    [theme.breakpoints.up('lg')]: {
      padding: '0 45px 100px 20px',
    },
  },

  placeOfOrigin: {
    rowGap: '20px',
  },
});
